import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=a7d55d76&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=js"
export * from "./TermsModal.vue?vue&type=script&lang=js"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=a7d55d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d55d76",
  null
  
)

export default component.exports